import {AnyEvent, JOB_FILE_UPLOAD_FAILED, JobFileUploadFailedEvent} from '../type';

export default function jobFileUploadFailed(payload: JobFileUploadFailedEvent['payload']): AnyEvent {
  return {
    type: JOB_FILE_UPLOAD_FAILED,
    payload,
  }
}